module.exports = __webpack_public_path__ + "img/solution12.91f03c22.jpg";